import React from "react";
import './CircularProgress.css'

const CircularProgress = ({className}) => <div className="progressLoader"><div className={`loader ${className}`}>
  <img src="/assets/images/loader.svg" alt="loader"/>
</div></div>;
export default CircularProgress;
